import { createBrowserRouter, RouterProvider } from 'react-router';
import { routeTree } from './routes/routeTree';

/* Created lazily, not at module scope. createBrowserRouter builds a browser
 * history, which reads `document` immediately — and this module is in the
 * chunk the BUILD-TIME prerender entry imports, so a module-scope call runs in
 * Node and fails the build with "document is not defined". Nothing renders
 * <App /> during prerendering (the static handler drives routeTree directly),
 * so deferring to first render is enough.
 *
 * A module-level singleton, not useMemo: the router owns navigation state, and
 * a fresh instance on re-render would reset it. */
let router: ReturnType<typeof createBrowserRouter> | null = null;

export default function App() {
  router ??= createBrowserRouter(routeTree);
  return <RouterProvider router={router} />;
}
